// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5015": "59cf926dd644","7916": "1d3818518fc9","8448": "8f0b63be48fc","9039": "248da94a30c0",}[chunkId] + ".css"
}